export const attributeKeys = [
  // primary type
  "PRICE",
  "ROOMS_COUNT",
  "SIZE",
  "FURNISHING_TYPE",
  "ENERGY_LABEL",
  // secondary type
  "PROPERTY_TYPE",
  "PLOT_AREA",
  "VOLUME",
  "BEDROOMS",
  "BATHROOMS",
  "NUMBER_OF_FLOORS",
  "HAS_GARDEN",
  "HAS_BALCONY",
  "HAS_TERRACE",
  "GARDEN_ORIENTATION",
  "GARDEN_SIZE",
  "CONSTRUCTION_YEAR",
  "PARKING_TYPE",
  "HAS_GARAGE",
  "GARAGE_SIZE",
  "AMENITIES",
  "SERVICE_COSTS",
  "PETS_ALLOWED",
  "CONTRACT_TYPE",
  "MAX_NUMBER_OF_TENANTS",
  "MIN_AGE",
  "PREF_GENDER",
  "AVAILABLE_FROM",
  "AVAILABLE_UNTIL",
  "MIN_DURATION",

  // tertiary type
  "CONDITION",
  "FLOOR_NUMBER",
  "HEATING_TYPE",
  "SMOKING_ALLOWED",
  "BUILDING_FACILITIES",
  "SHARED_FACILITIES",
  "DEPOSIT_AMOUNT",
  "GARDEN_DESCRIPTION",
  "TENANT_TYPE",
  "MUSICAL_INSTRUMENTS",
  "KITCHEN_TYPE",
  "COOKTOP_TYPE",
  "ENERGY_SOURCE",
  "APPLIANCES",
  "RENOVATION_YEAR",
  "BIKE_STORAGE",
  "STORAGE_PRESENT",
  "STORAGE_SIZE",
  "WWS_POINTS",
  "IS_SOCIAL_HOUSING",
  "IS_BOAT",
] as const;

export type AttributeKey = (typeof attributeKeys)[number];

export const propertyTypes = [
  "HOUSE",
  "APARTMENT",
  "PARKING",
  "ROOM",
  "STUDIO",
] as const;

export type ListingType = (typeof propertyTypes)[number];

export const conditionTypes = [
  "NEW",
  "GOOD",
  "MODERATE",
  "POOR",
  "RENOVATED",
] as const;

export const parkingTypes = ["PRIVATE", "GATED", "STREET"] as const;

export const petsAllowedTypes = ["YES", "NO", "CONDITIONAL"] as const;

export const tenantTypes = ["WORKING", "STUDENT"] as const;

export const buildingFacilities = [
  "GYM",
  "LAUNDRY",
  "SHARED_WORKSPACE",
  "ROOFTOP",
  "SECURITY",
  "ELEVATOR",
  "POOL",
] as const;
